export default __webpack_public_path__ + "static/media/vinuri-piyathilake.ff06c47b.pdf";